module.exports = __webpack_public_path__ + "img/tiktok.ad85749d.png";